import React from 'react';
import './terms.css';

const Terms = () => (
  <section id="terms">
    <h2>Terms and Service</h2>
    <p>Welcome to Event Planner! Please read these Terms of Service ("Terms") carefully before using our application and services.</p>
    
    <h3>1. Acceptance of Terms</h3>
    <p>By accessing or using Event Planner, you agree to be bound by these Terms. If you disagree with any part of the Terms, you may not access the service.</p>

    <h3>2. Use of Service</h3>
    <p>You agree to use Event Planner only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the service.</p>

    <h3>3. Account Responsibilities</h3>
    <p>You are responsible for maintaining the confidentiality of your account information, including your password, and for all activities that occur under your account.</p>

    <h3>4. Termination</h3>
    <p>We may terminate or suspend your access to Event Planner immediately, without prior notice or liability, for any reason, including if you breach the Terms.</p>

    <h3>5. Limitation of Liability</h3>
    <p>In no event shall Event Planner, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the service.</p>

    <h3>6. Changes to Terms</h3>
    <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p>

    <h3>Contact Us</h3>
    <p>If you have any questions about these Terms, please contact us.</p>
  </section>
);

export default Terms;
